import { render } from "./B1Data.vue?vue&type=template&id=838520e4"
import script from "./B1Data.vue?vue&type=script&lang=js"
export * from "./B1Data.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__